import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Cookie, X } from "lucide-react";

const KEY = "otelpro-cookie-accepted";

export default function CookieBanner() {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        try {
            if (!localStorage.getItem(KEY)) setVisible(true);
        } catch (_) {}
    }, []);
    const accept = () => {
        try {
            localStorage.setItem(KEY, "1");
        } catch (_) {}
        setVisible(false);
    };
    if (!visible) return null;
    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-0 inset-x-0 z-40 bg-dark-navy/95 backdrop-blur text-white border-t border-white/10"
        >
            <div className="max-w-7xl mx-auto px-4 lg:px-6 py-3 flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-6">
                <div className="flex items-start gap-3 text-sm text-white/85">
                    <Cookie className="w-5 h-5 text-gold shrink-0 mt-0.5" />
                    <p>{t("cookie.text")}</p>
                </div>
                <div className="flex items-center gap-2 ml-auto">
                    <button
                        onClick={accept}
                        className="bg-teal hover:bg-teal-700 text-dark-navy font-semibold text-sm px-4 py-2 rounded-md"
                        data-testid="cookie-accept"
                    >
                        {t("cookie.accept")}
                    </button>
                    <button
                        onClick={accept}
                        aria-label="Dismiss"
                        className="p-2 rounded-md hover:bg-white/10 text-white/70"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
